<!-- 搜索结果页 -->
<template>
  <div>
    <my-header>
    </my-header>
    <div class="searchs">
          <div class="search">
            <div class="search-input">
              <input type="text" v-model="SearchName" @keyup.enter="ToSearch" placeholder="搜索你喜欢的……" />
            </div>
            <div class="drop-down">
              <p class="drop-header" @click="isShowSize=!isShowSize">{{fristName}}</p>
              <transition name="opacityLeave">
                <div class="condition-list" v-if="isShowSize">
                  <div class="size-wrap" v-if="CategoryData">    
                       <p class="size" :class="{'active':index==activeIndex}" v-for="(item, index) in CategoryData" :key="index"  @click="getSize (index,item.Name) ">
                         {{item.Name}}
                         </p>
                  </div>
                </div>
              </transition>
            </div>
            <div class="search-btn"  @click="ToSearch"></div>
          </div>
    </div>
    <div class="searchTop">
      <p>
        <span>{{Search.TitleName}}</span>：当前共
        <span>{{TotalNum}}</span>个结果
      </p>
      <div class="searchCondition">
        <b>筛选：</b>
        <div class="searchUl">
          分类筛选
          <div class="searchUl_list">
            <ul class="searchUl_1">
              <li
                :class="{'actived':index==SelectedIndex}"
                v-for="(item,index) in CategoryData"
                :key="index"
              >
                <span @click="PrimarySelection(item.Name,index)">{{item.Name}}</span>
                <ul class="searchUl_2">
                  <li
                    :class="{'actived':index==SelectedIndex&&index2==SelectedIndex2}"
                    v-for="(item2,index2) in item.Children"
                    :key="index2"
                  >
                    <span @click="SecondarySelection(item.Name,index2,index)">{{item2.Name}}</span>
                    <ul class="searchUl_3" v-if="item2.Children && item2.Children.length>0">
                      <li
                        :class="{'actived':index==SelectedIndex&&index2==SelectedIndex2&&index3==SelectedIndex3}"
                        v-for="(item3,index3) in item2.Children"
                        :key="index3"
                      >
                        <span @click="ThreeSelection(index3,index2,index,item3.Id)">{{item3.Name}}</span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="searchUl">
          时间范围
          <div class="searchUl_list">
            <ul class="searchUl_1">
              <li
                :class="{'actived':index==chooseTimeIndex}"
                v-for="(item,index) in Times"
                :key="index"
                @click="chooseTime(item.Id,index)"
              >{{item.Name}}</li>
            </ul>
          </div>
        </div>
        <div class="searchUl">
          更多条件
          <ul class="searchUl_more">
            <li v-for="(row,index) in DirsData.Children" :key="index">
              <div class="searchUl_left">{{row.Name}}</div>
              <div class="searchUl_right">
                <label v-for="(item,index1) in row.Children " :key="index1">
                  <input
                    type="checkbox"
                    v-model="item.flag"
                    @click="multipleSelection(row.Id,item.Id,!item.flag)"
                  />
                  {{item.Name}}
                </label>
              </div>
            </li>
           
          </ul>
        </div>
        <div class="more_cond">
          <label>
            <input type="checkbox" @click="hot(!hotFlag)" v-model="hotFlag" />热门
          </label>
          <em></em>
          <label
            v-for="(item,index) in imgType"
            :key="index"
            @click="selectRes(item.label2,index,!item.flag)"
          >
            <input type="checkbox" v-model="item.flag" />
            {{item.label1}}
          </label>
        </div>
      </div>
    </div>
    <div v-if="waterfallShow">
      <waterfall
        :isWaterfall="true"
        :apiType="3"
        :isPick="true"
        :fileList="Search"
        @totalNum="getTotalNum"
      ></waterfall>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<script>
import waterfall from "../common/waterfall";
import { GetSearchDir, GetDirs } from "../../assets/js/modules/indexApi";
import { throws } from "assert";
import search from "../common/search";

var time = [
  { Id: "0", Name: "全部" },
  { Id: "CreateTime", Name: "最新" },
  { Id: "1", Name: "一个月内" },
  { Id: "2", Name: "半年内" },
  { Id: "3", Name: "一年内" },
  { Id: "4", Name: "一年前" }
];
var imgTypes = [
  { label1: "JPG", label2: "jpg", flag: false },
  { label1: "PNG", label2: "png", flag: false },
  { label1: "PSD", label2: "psd", flag: false }
];

export default {
  inject: ["reload"],
  data() {
    return {
      isShowSize: false,
      activeIndex: "0",
      fristName:"",
      SearchName:"",
      DirsData: [], //获取搜索更多条件列表
      CategoryData: [], //分类列表数据
      hotFlag: false, //热门是否被选中
      imgType: imgTypes, //图片类型
      SelectedIndex: "-1",
      SelectedIndex2: "-1",
      SelectedIndex3: "-1",
      waterfallShow: false,
      Times: time, //日期选择
      TotalNum: 0,
      chooseTimeIndex: "0",
      SortingString: [],
      Search: {
        IsHomePage: false,
        SecondLevelCatelogId: [],
        ThirdLevelCatelogId: 0,
        FileClassify: 1,
        ImgExtensType: [],
        FourLevelCatelogId:"0",
        LabelIds: [],
        TitleName: "",
        TimeFrame: 0,
        Sorting: "",
        LabelName: "",
        MinClassifies:[],
      }
    };
  },
  components: { waterfall,search },
  created() {},
  methods: {
   ToSearch(){
          // this.$router.push({
          //   path: "/searchResList",
          //   query: { Name:this.fristName, TitleName:  this.SearchName }
          // });
          if(this.SearchName){
            this.Search.TitleName=this.SearchName;
            this.Search.LabelName=this.SearchName;
            this.PrimarySelection(this.fristName, this.activeIndex)
          }
          

   },
    // //实现选取下拉值
    getSize(index,name) {
      this.isShowSize = !this.isShowSize;
      this.fristName=name;
      this.activeIndex = index;
    },

    // 瀑布流刷新
    waterfallRefresh() {
      this.waterfallShow = false;
      this.$nextTick(() => {
        this.waterfallShow = true;
      });
    },
    // 查是否存在该数组
    arrayCheck(array, obj) {
      var thatIndex = -1;
      array.forEach(function(item, index) {
        if (obj == item) {
          thatIndex = index;
        }
      });
      return thatIndex;
    },
    // 获取搜索更多条件列表
    GetDirs() {
      GetDirs().then(res => {
        if (res.data.Success) {
          this.DirsData = res.data.Data;
   
        }
      });
    },
    // 获取搜索数据
    GetSearchDir() {
      GetSearchDir().then(res => {
        if (res.data.Success) {
          if (!window.localStorage.userInfo) {
            res.data.Data.splice(1, 1);
          }
          this.CategoryData = res.data.Data;
           this.fristName=this.CategoryData[0].Name
          if (this.$route.query.TitleName) {
            this.Search.TitleName = this.$route.query.TitleName;
            this.Search.LabelName = this.$route.query.TitleName;
          }
          if (this.$route.query.Name) {
            this.CategoryData.forEach((item, index) => {
              if (item.Name == this.$route.query.Name) {
                this.PrimarySelection(this.$route.query.Name, index);
                return;
              }
            });
          }
          if (this.$route.query.InteralDirId) {
            var InteralDirId = this.$route.query.InteralDirId;
            this.CategoryData.forEach((item, index) => {
              if (item.Id == InteralDirId) {
                this.SelectedIndex = index;
                return;
              }
              item.Children.forEach((item2, index2) => {
                if (item2.Id == InteralDirId) {
                  this.SelectedIndex = index;
                  this.SelectedIndex2 = index2;
                  return;
                }
                if (item2.Children) {
                  item2.Children.forEach((item3, index3) => {
                    if (item3.Id == InteralDirId) {
                      this.SelectedIndex = index;
                      this.SelectedIndex2 = index2;
                      this.SelectedIndex3 = index3;
                      return;
                    }
                  });
                }
              });
            });
            if (this.CategoryData[this.SelectedIndex].Name == "设计交流") {
              this.Search.FileClassify = 2;
            }
            this.Search.SecondLevelCatelogId[0] = InteralDirId;
          }
          this.waterfallShow = true;
        }
      });
    },
    PrimarySelection(name, index) {
      this.SelectedIndex = index;
      this.SelectedIndex2 = "-1";
      this.SelectedIndex3 = "-1";
      this.Search.ThirdLevelCatelogId = 0;
      this.Search.SecondLevelCatelogId = [];
      if (name == "全部图片") {
        this.CategoryData[index].Children.forEach((item, index) => {
          item.Children.forEach((item1, index1) => {
            //this.Search.SecondLevelCatelogId.push(item1.Id);
            this.Search.SecondLevelCatelogId = [];
          });
        });
        this.Search.FileClassify = 1;
      } else if (name == "集团VI") {
        this.Search.SecondLevelCatelogId.push(this.CategoryData[index].Id);
        this.Search.FileClassify = 1;
      } else if (name == "PPT") {
        this.CategoryData[index].Children.forEach((item, index) => {
          this.Search.SecondLevelCatelogId.push(item.Id);
        });
        this.Search.FileClassify = 1;
      } else if (name == "设计交流") {
        this.CategoryData[index].Children.forEach((item, index) => {
          this.Search.SecondLevelCatelogId.push(item.Id);
        });
        this.Search.FileClassify = 2;
      }
      this.waterfallRefresh();
      // console.log(this.Search.SecondLevelCatelogId);
    },
    SecondarySelection(name, index2, index) {
      this.SelectedIndex2 = index2;
      this.SelectedIndex = index;
      this.SelectedIndex3 = "-1";
      this.Search.ThirdLevelCatelogId = 0;
      this.Search.SecondLevelCatelogId = [];
      if (name == "全部图片") {
        this.CategoryData[index].Children[index2].Children.forEach(
          (item, index) => {
            //this.Search.SecondLevelCatelogId.push(item.Id);
            this.Search.SecondLevelCatelogId = [];
          }
        );
        this.Search.FileClassify = 1;
      } else if (name == "集团VI") {
        this.Search.SecondLevelCatelogId.push(this.CategoryData[index].Id);
        this.Search.ThirdLevelCatelogId = this.CategoryData[index].Children[
          index2
        ].Id;
        this.Search.FileClassify = 1;
      } else if (name == "PPT") {
        this.Search.SecondLevelCatelogId.push(
          this.CategoryData[index].Children[index2].Id
        );
        this.Search.FileClassify = 1;
      } else if (name == "设计交流") {
        this.Search.SecondLevelCatelogId.push(
          this.CategoryData[index].Children[index2].Id
        );
        this.Search.FileClassify = 2;
      }
      this.waterfallRefresh();
    },
    ThreeSelection(index3, index2, index, id) {
      this.SelectedIndex3 = index3;
      this.SelectedIndex2 = index2;
      this.SelectedIndex = index;
      this.Search.ThirdLevelCatelogId = 0;
      this.Search.SecondLevelCatelogId = [];
      this.Search.SecondLevelCatelogId.push(id);
      this.Search.FileClassify = 1;
      this.waterfallRefresh();
    },
    // 选择时间
    chooseTime(id, index) {
      this.chooseTimeIndex = index;
      var SortingIndex = this.arrayCheck(this.SortingString, "CreateTime");

      if (id !== "CreateTime") {
        this.Search.TimeFrame = id;
        if (SortingIndex > -1) {
          this.SortingString.splice(SortingIndex, 1);
          this.Search.Sorting = this.SortingString.join(",");
        }
      } else {
        if (SortingIndex == -1) {
          this.SortingString.push("CreateTime");
          this.Search.Sorting = this.SortingString.join(",");
        }
      }
      this.waterfallRefresh();
    },
    //条件多项选择
    multipleSelection(ParentId,id, flag) {
        var MinClassifiesItem={
        Id: id,
        ParentId: ParentId
      }
      var IsIndex=-1;
     this.Search.MinClassifies.forEach((item,index)=>{
        if(item.Id==id){
         IsIndex=index;
         return   
        }
     })
      if (flag) {
        if(IsIndex<0){
          this.Search.MinClassifies.push(MinClassifiesItem);
        }
      } else {
        if(IsIndex>=0){
          this.Search.MinClassifies.splice(IsIndex, 1);
        }
      }
      this.waterfallRefresh();
    },
    //  热门
    hot(flag) {
      var SortingIndex = this.arrayCheck(this.SortingString, "Hot");
      if (flag) {
        if (SortingIndex == -1) {
          this.SortingString.push("Hot");
          this.Search.Sorting = this.SortingString.join(",");
        }
      } else {
        if (SortingIndex > -1) {
          this.SortingString.splice(SortingIndex, 1);
          this.Search.Sorting = this.SortingString.join(",");
        }
      }

      this.waterfallRefresh();
    },
    //查询图片类型数据
    selectRes(obj, index, flag) {
      var index = this.arrayCheck(this.Search.ImgExtensType, obj);
      if (flag) {
        if (index == -1) {
          this.Search.ImgExtensType.push(obj);
        }
      } else {
        if (index > -1) {
          this.Search.ImgExtensType.splice(index, 1);
        }
      }
      this.waterfallRefresh();
    },
    // 获取总条数
    getTotalNum(data) {
      this.TotalNum = data;
    }
  },
  mounted() {
    this.GetSearchDir();
    this.GetDirs();
  },

  watch: {
    $route(to, from) {}
  }
};
</script>
<style scoped>
.searchTop {
  width: 100%;
  background-color: #fff;
  border-top: 2px solid #f3f4f6;
  border-bottom: 1px solid #f3f4f6;
  z-index: 888;
  position: relative;
}
.searchTop > p {
  width: 1280px;
  height: 60px;
  line-height: 60px;
  color: #666;
  font-size: 16px;
  margin: 0 auto;
  border-bottom: 1px solid #f3f4f6;
}
.searchCondition {
  width: 1280px;
  height: 60px;
  line-height: 60px;
  color: #333;
  font-size: 14px;
  margin: 0 auto;
}
.searchCondition > b {
  display: block;
  height: 60px;
  line-height: 60px;
  float: left;
  font-size: 16px;
}
.searchUl {
  width: 105px;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
  background: url(../../assets/img/searchUl_bg.png) no-repeat;
  background-position: 86px 26px;
  margin: 0 0 0 30px;
  position: relative;
  float: left;
  text-align: center;
  font-size: 16px;
}
.searchUl:hover .searchUl_list {
  display: block;
}
.searchUl_list:hover {
  display: block;
}
.searchUl_list {
  display: none;
  position: relative;
  border-right: none;
  border-radius: 5px;
  background-color: #fff;
}
.searchUl_list ul {
  background-color: #fff;
  color: #666;
  padding: 20px 0 30px;
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  min-height: 120px;
}
.searchUl_list ul li {
  height: 30px;
  line-height: 30px;
  /* padding: 0 20px; */
  font-size: 14px;
}
.actived {
  background-color: #e7e7e7;
}
.searchUl_list ul li:hover {
  background-color: #e7e7e7;
}
.searchUl_list ul li span {
  display: block;

  width: 100%;
}
.searchUl_1 li:hover .searchUl_2 {
  display: block;
}
.searchUl_2 {
  display: none;
  width: 145px;
  position: absolute;
  left: 102px;
  top: 0;
  z-index: 100;
}
.searchUl_2 li:hover .searchUl_3 {
  display: block;
}
.searchUl_3 {
  display: none;
  width: 145px;
  position: absolute;
  left: 142px;
  top: -2px;
  z-index: 200;
}
.searchUl:hover .searchUl_more {
  display: block;
}
.searchUl_more {
  display: none;
  background-color: #fff;
  color: #666;
  padding: 20px 20px 30px;
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  position: absolute;
  width: 190px;
}
.searchUl_more li {
  line-height: 30px;
  position: relative;
  height: 100%;
  overflow: hidden;
  font-size: 14px;
}
.searchUl_more li input {
  margin: 0 5px 0 3px;
}
.searchUl_left {
  float: left;
  width: 70px;
  margin-right: 0;
}
.searchUl_right {
  float: left;
  width: 120px;
  text-align: left;
}
.more_cond {
  margin-left: 50px;
  float: left;
}
.more_cond label {
  margin-right: 25px;
}
.more_cond input {
  margin: 0 5px 0 3px;
}
.more_cond em {
  width: 1px;
  height: 30px;
  background-color: #e7e7e7;
  display: inline-block;
  margin: 0 25px 0 0;
  position: relative;
  top: 10px;
}
.searchs{
  height: 210px;  
   padding-top: 140px;
  background: url("../../assets/img/news_bg.jpg") no-repeat center;
}
.search {
  width: 700px;
  height: 50px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 35px;
  margin: 0 auto;
  color: #333333;
 
}
.active {
  background: #6aa9ff;
  color: #fff;
}
.search-input {
  float: left;
  width: 390px;
  height: 40px;
  margin-top: 5px;
  border-right: 1px solid #999999;
}
.search-input input {
  width: 360px;
  height: 40px;
  border: none;
  /* background: #000; */
  background-color: transparent !important;
  padding-left: 30px;
  outline: none;
}
.search-input input:focus {
  background-color: transparent !important;
}

.drop-down {
  float: left;
  width: 120px;
  margin-top: 10px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  position: relative;
}
.drop-header {
  background: url("../../assets/img/down_icon.png") no-repeat 90px center;
  text-align: left;
  padding-left: 14px;
}
.condition-list {
  overflow: hidden;
  background: rgba(255, 255, 255, 0.7);
  margin-top: 10px;
  position: absolute;
  width: 100%;
}
.size:hover {
  color: #fff;
  background: #6aa9ff;
}
.size-wrap {
  /* padding: 10px 0; */
}
.opacityLeave-enter-active {
  animation-name: fold-in;
  animation-duration: 0.5s;
}
.opacityLeave-leave-active {
  animation-name: fold-out;
  animation-duration: 0.5s;
}
@keyframes fold-in {
  0% {
    height: 0;
  }

  100% {
    height: 100px;
  }
}
@keyframes fold-out {
  0% {
    height: 100px;
  }

  100% {
    height: 0;
  }
}
.search-btn {
  float: right;
  width: 170px;
  height: 50px;
  background: url("../../assets/img/search_icon.png") #6aa9ff no-repeat center
    center;
  border-radius: 35px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/index/searchResList.vue